module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isBoxShow),
      expression: "isBoxShow"
    }],
    staticClass: "message-pop message-box"
  }, [_c('div', {
    staticClass: "message-pop-wrapper"
  }, [_c('div', {
    staticClass: "pop-header clearfix"
  }, [_c('p', {
    staticClass: "fl"
  }, [_vm._v("与 "), (_vm.from_to[_vm.uid]) ? _c('span', {
    staticClass: "uname"
  }, [_vm._v(_vm._s(_vm.from_to[_vm.uid].nick_name))]) : _vm._e(), _vm._v(" 的对话")]), _vm._v(" "), _c('a', {
    staticClass: "fr s-popup-close",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.closeBox
    }
  }, [_vm._m(0)])]), _vm._v(" "), _c('div', {
    staticClass: "pop-body"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.page.curPage < _vm.page.totalPage && !_vm.isLoading),
      expression: "page.curPage<page.totalPage&&!isLoading"
    }],
    staticClass: "load-more",
    on: {
      "click": function($event) {
        _vm.getMsgList(parseInt(_vm.page.curPage) + 1)
      }
    }
  }, [_c('i', {
    staticClass: "icon-clock-blue"
  }), _vm._v("查看更多消息\n      ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.page.curPage < _vm.page.totalPage && _vm.isLoading),
      expression: "page.curPage<page.totalPage&&isLoading"
    }],
    staticClass: "loading-box"
  }, [_c('img', {
    staticClass: "loading",
    attrs: {
      "width": "16",
      "height": "16",
      "src": require("../../../images/common/loading_2_24x24.gif")
    }
  }), _vm._v("加载中\n      ")]), _vm._v(" "), _c('ul', {
    staticClass: "msg-list"
  }, _vm._l((_vm.msgList), function(item) {
    return _c('li', {
      staticClass: "msg-item clearfix",
      class: [item.is_me ? 'msg-item-right' : 'msg-item-left', 'msg' + item.msg_id]
    }, [_c('div', {
      staticClass: "avatar-box"
    }, [(_vm.from_to[item.from_id].user_logo.indexOf('?') == 0) ? _c('img', {
      staticClass: "avatar",
      attrs: {
        "width": "60",
        "height": "60",
        "src": require("../../../images/personal_center/avatar_default.png"),
        "alt": ""
      }
    }) : _c('img', {
      staticClass: "avatar",
      attrs: {
        "width": "60",
        "height": "60",
        "src": _vm.from_to[item.from_id].user_logo,
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "content-box"
    }, [_c('p', {
      staticClass: "time"
    }, [_vm._v(_vm._s(item.create_time))]), _vm._v(" "), _c('div', {
      staticClass: "content"
    }, [_c('i', {
      staticClass: "corner"
    }), _c('pre', {
      domProps: {
        "innerHTML": _vm._s(item.content)
      }
    })])])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "pop-footer"
  }, [_c('div', {
    staticClass: "text-box"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.msg.content),
      expression: "msg.content"
    }],
    staticClass: "text",
    attrs: {
      "placeholder": "在此输入回复内容",
      "name": "name",
      "rows": "8",
      "cols": "80",
      "maxlength": "200"
    },
    domProps: {
      "value": (_vm.msg.content)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.msg, "content", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "send"
  }, [(200 - _vm.msg.content.length >= 0) ? _c('span', [_vm._v("还可以输入 "), _c('span', {
    staticClass: "number"
  }, [_vm._v(_vm._s(200 - _vm.msg.content.length))]), _vm._v(" 个字符")]) : _c('span', [_vm._v("已超出 "), _c('span', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.msg.content.length - 200))]), _vm._v(" 个字符")]), _vm._v(" "), (!_vm.msg.isSubmit) ? _c('a', {
    staticClass: "send-msg",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": _vm.sendMsg
    }
  }, [_vm._v("发送")]) : _c('a', {
    staticClass: "send-msg",
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_c('img', {
    staticClass: "loading",
    attrs: {
      "src": require("../../../images/common/loading_16.svg"),
      "alt": ""
    }
  }), _vm._v("提交中")])])])]), _vm._v(" "), _c('v-alert', {
    attrs: {
      "options": _vm.options
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('img', {
    attrs: {
      "src": require("../../../images/common/close.png"),
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-678781e4!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/personal_center/message/message_box.vue
// module id = W3z8
// module chunks = 16